<template>
  <div class="kpt-sub-terminal-selector">
    <b-input type="text" icon="search" @input="getFilteredTerminals" v-model="searchTerm" :loading="fetchingTerminals" placeholder="Search by remote name or modem serial..."></b-input>
    <b-table 
      :data="availableTerminals" 
      :loading="fetchingTerminals"
      :scrollable="false"
      checkable 
      :header-checkable="false"
      :is-row-checkable="(row) => isRowCheckable(row)"
      :custom-is-checked="(a, b) => a.id === b.id"
      :checked-rows="checkedTerminals"
      :paginated="true"
      :per-page="5"
      :pagination-simple="true"
      @check="emitUpdate"
      :current-page="currentPage">
      <b-table-column field="name" label="Name" v-slot="props">
        {{ props.row.name }}
      </b-table-column>
      <b-table-column field="accountId" label="Account" v-slot="props">
        {{ getAccountNameFromId(props.row.accountId) }}
      </b-table-column>
      <b-table-column field="hardware.geoModem.serial" label="GeoModem Serial" v-slot="props">
        {{ props.row.hardware?.geoModem?.serial || '-' }}
      </b-table-column>
      <template slot="empty">
        <p v-if="!fetchingTerminals">No available terminals found.</p>
        <p v-else>Loading terminals...</p>
      </template>
    </b-table>
  </div>
</template>
<script setup>
import { 
  ref, defineProps, defineEmits, onMounted 
} from 'vue';
import { debounce } from 'lodash';
import { useTerminalsStore } from '../terminals-store';
import getAccountNameFromId from '../../utilities/getAccountNameFromId';

const searchTerm = ref('');
const availableTerminals = ref([]);
const checkedTerminals = ref([]);
const fetchingTerminals = ref(false);
const currentPage = ref(1);
const props = defineProps(['isMultipleSelect', 'accountFilter', 'preSelected']);
const emit = defineEmits(['item-select']);

const store = useTerminalsStore();

// eslint-disable-next-line func-names
const getFilteredTerminals = debounce(async (t) => {
  fetchingTerminals.value = true;
  const terminals = await store.dispatch('fetchTerminals', { 
    skipCommit: true, 
    skip: 0,
    take: 10000, 
    query: t, 
    fields: 'Id,Name,AccountId,Hardware.GeoModem.Serial' 
  });
  fetchingTerminals.value = false;
  availableTerminals.value = terminals.items;
});
const emitUpdate = (terminals) => {
  checkedTerminals.value = terminals;
  emit('item-select', checkedTerminals.value);
}
const isRowCheckable = (row) => {
  const existsInList = checkedTerminals.value.find(r => r.id == row.id) != null;
  if (existsInList) return true;
  return props.isMultipleSelect ? true : checkedTerminals.value.length < 1;
}

onMounted(async () => {
  await getFilteredTerminals();
})
</script>
<style lang="scss" scoped>
.kpt-sub-terminal-selector {
  ::v-deep .table-wrapper {
    overflow: hidden;
  }
}
</style>
